"use strict";

exports.__esModule = true;
exports.getOwnerIcon = getOwnerIcon;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _color = _interopRequireDefault(require("color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getOwnerIcon({
  fill = "#000",
  text = "N/A"
}) {
  let contrast;
  fill = (0, _color.default)(fill);

  if (fill.isDark()) {
    contrast = 'white';
  } else {
    contrast = 'black';
  }

  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    viewBox: "0 0 64 64"
  }, _react.default.createElement("circle", {
    cx: "32",
    cy: "32",
    r: "27",
    fill: fill
  }), _react.default.createElement("text", {
    x: "32",
    y: "34",
    fill: contrast,
    fontFamily: "Akkurat, sans-serif",
    fontSize: "18",
    fontWeight: "normal",
    dominantBaseline: "middle",
    textAnchor: "middle"
  }, text));
}

var _default = getOwnerIcon;
exports.default = _default;